import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=3fa24e12"
import script from "./Faqs.vue?vue&type=script&lang=ts"
export * from "./Faqs.vue?vue&type=script&lang=ts"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=3fa24e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports